import { t } from "i18next"

const workflowInitiateFormTranformer = data => {
  let rulesList = {}
  let componentList = {}
  let dataList = {}

  data?.initiationData?.inputs?.forEach((item, index) => {
    rulesList[index] = {
      required: item?.required,
      message: t(`${item?.title} is required`),
    }
    componentList[index] = {
      type: item?.config?.isNumeric ? "numeric" : item?.type,
      label: item?.title,
      key: item?.key,
    }
    dataList[index] = {
      options: item?.config?.options || [],
      ...(!item?.config?.enableMultiSelect && item?.type === "dropdown" && { maxCount: 1 }),
      placeholder: t("Please Select "),
    }
  })

  let workFlowDescription = [
    { label: t("Workflow Name"), data: data?.name },
    { label: t("Workflow Type"), data: data?.type },
    { label: t("Total Stages"), data: data?.stageData?.length },
  ]

  return { rulesList, componentList, dataList, workFlowDescription, data }
}

export default workflowInitiateFormTranformer
